import React, { useContext, useState } from "react";
import SidebarContext from "../../../context/SidebarContext";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import logo from "../../../assets/svg/fedex.svg";
import loc from "../../../assets/svg/loc.svg";
import ShippingServiceOverview from "./ShippingServiceOverview";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useDispatch, useSelector } from "react-redux";
import { setShippingServiceState } from "../../../store/shippingServiceSlice";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ minHeight: "78vh", maxHeight: "78vh" }}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default function ShippingServiceDetails() {
  const { open } = useContext(SidebarContext);
  const [value, setValue] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const shippingService = useSelector(state => state.shippingService.shippingServiceData);

  useEffect(() => {
    const fetchShippingService = async () => {
      try {
        const docRef = doc(db, "shippingServices", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          dispatch(setShippingServiceState({ ...docSnap.data(), id }));
        }
      } catch (error) {
        // Optionally handle error
      }
    };
    fetchShippingService();
  }, [id, dispatch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box>
        <Box>
          <Box sx={{ height: "80px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  <img
                    src={logo}
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "50%",
                    }}
                    alt="logo"
                  />
                </Box>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: " 26px",
                      fontWeight: "bold",
                    }}
                  >
                    Parcel.com
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box>
                      <img src={loc} alt="address" />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                        Daleware, United States
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "#000000",
                    border: "1px solid #E5E5E8",
                    borderRadius: "4px",
                    boxShadow: "none",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    marginTop: "20px",
                    "&:hover": {
                      outline: "none",
                      color: "#000000",
                      backgroundColor: "#ffffff",
                    },
                  }}
                >
                  Edit Shipping Service
                </Button>
              </Box>
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="route partner tabs"
            >
              <Tab label="Overview" />
              <Tab label="Bookings" />
            </Tabs>
            <TabPanel value={value} index={0}>
              <ShippingServiceOverview data={shippingService} />
            </TabPanel>
            <TabPanel value={value} index={1}></TabPanel>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
